
import { useEffect } from 'react'

import useJitsiMeet from './useJitsiMeet';

import { Props } from './JitsiMeet.model';

const JitsiMeet = ({
  containerStyles,
  errorComponent,
  jitsiContainerStyles,
  loadingComponent,
  onError,
	onMeetingStart,
	organizerId,
  ...options

}: Props) => {
	const { error, jitsi } = useJitsiMeet({
		organizerId,
    parentNode: 'jitsi-container',
    ...options,
  });

  useEffect(() => {
    if (jitsi && onMeetingStart) onMeetingStart(jitsi)
  }, [jitsi])
	
  return (
    <div style={{ ...containerStyles }}>
      { error && <p>{error}</p>}
      <div
        id='jitsi-container'
        style={{ ...{
          height: '100%',
          width: '100%',
        },
        ...jitsiContainerStyles }}
      />
    </div>
  )
}

export { JitsiMeet, useJitsiMeet };